<template lang="pug">
div
  //- alert
  v-alert.round-xl.mt-6(v-if="offer.status === 'scheduled'" color="neutral400" text outlined)
    div.d-flex.align-center
      v-icon.mr-2(size="16" color="neutral500") $yzi-alert-square
      div.text-xs.neutral700--text Some of the details can’t be edited after your campaign has been commenced and sent.
  v-alert.round-xl.mt-6(v-if="offer.status === 'active'" color="yellow500" text outlined)
    div.d-flex.align-center
      v-icon.mr-2(size="16" color="yellow600") $yzi-alert-square
      div.text-xs.neutral700--text Your campaign has already been commenced and sent. Some of the details are now cannot be edited

  v-form(ref="form")
    //- name
    v-card.pa-6.mt-4.round-xl(outlined)
      template(v-if="editable === 'name'")
        v-row
          v-col(cols="6")
            div.text-md.font-semibold.neutral700--text Campaign name
            .text-sm.neutral700--text(style="margin-top: 2px;") Enter the name of your campaign.
            v-text-field.text-sm.mt-2.round-xl(v-model="offer.name" placeholder="Enter your campaign name" outlined dense height="48" hide-details="auto")
        div.d-flex.justify-end.mt-3
          y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="updateEditable(null)")
          y-button(label="Save" color="neutral700" size="sm" dark :loading="isLoading" @click="saveData")
      div.d-flex.align-center(v-else)
        div
          div.text-md.font-semibold.neutral700--text Campaign name
          ul.mt-5
            li.text-md.neutral700--text.ml-2 {{ storedOffer.name }}
        v-spacer
        y-button(label="Edit" size="sm" outlined :disabled="disableEdit('name')" @click="updateEditable('name')")

    //- redeem_method
    v-card.pa-6.mt-4.round-xl(outlined)
      template(v-if="editable === 'redeem_method'")
        v-row
          v-col(cols="6")
            div.text-md.font-semibold.neutral700--text How to redeem
            .text-sm.neutral700--text(style="margin-top: 2px;") Set on how your customer will redeem this offer
            v-radio-group.mt-0(v-model="offer.redeem_method" @change="sanitizeUnusedObject(['coupon_code'])")
              v-radio.mt-3(value="show_message" color="neutral700")
                template(v-slot:label)
                  div.text-md.font-medium.neutral700--text Show message at counter
              v-radio.mt-3(value="general_code" color="neutral700" style="align-items: unset;")
                template(v-slot:label)
                  div.text-md.font-medium.neutral700--text Create general coupon code
              template(v-if="offer.redeem_method && offer.redeem_method === 'general_code'")
                v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="offer.coupon_code" placeholder="Enter your code here" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
              v-radio.mt-3(value="unique_code" color="neutral700")
                template(v-slot:label)
                  div.text-md.font-medium.neutral700--text Generate unique coupon code for every customer
        div.d-flex.justify-end.mt-3
          y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="updateEditable(null)")
          y-button(label="Save" color="neutral700" size="sm" dark :loading="isLoading" @click="saveData")
      div.d-flex.align-center(v-else)
        div
          div.text-md.font-semibold.neutral700--text How to redeem
          ul.mt-5(v-if="storedOffer.redeem_method")
            li.text-md.neutral700--text.ml-2(v-if="storedOffer.redeem_method === 'show_message'") Redeem show message at counter
            li.text-md.neutral700--text.ml-2(v-if="storedOffer.redeem_method === 'general_code'") Redeem general coupon code
            li.text-md.neutral700--text.ml-2(v-if="storedOffer.redeem_method === 'unique_code'") Redeem unique coupon code
        v-spacer
        y-button(label="Edit" size="sm" outlined :disabled="disableEdit('redeem_method')" @click="updateEditable('redeem_method')")

    //- item_applies
    v-card.pa-6.mt-4.round-xl(outlined)
      template(v-if="editable === 'item_applies'")
        div.text-md.font-semibold.neutral700--text Applies to
        v-radio-group.mt-0(v-model="offer.upon_any_purchase" @change="sanitizeUnusedObject(null,['purchase_products'])")
          v-radio.mt-3(:value="true" color="neutral700")
            template(v-slot:label)
              div.text-md.font-medium.neutral700--text All inventory & services
          v-radio.mt-3(:value="false" color="neutral700" style="align-items: unset;")
            template(v-slot:label)
              div.text-md.font-medium.neutral700--text Specific inventory & services
        template(v-if="offer.hasOwnProperty('upon_any_purchase') && !offer.upon_any_purchase")
          inventory-services-selection.mb-6(v-model="offer.purchase_products")
        div.d-flex.justify-end.mt-3
          y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="updateEditable(null)")
          y-button(label="Save" color="neutral700" size="sm" dark :loading="isLoading" @click="saveData")
      template(v-else)
        div.d-flex.align-center
          div
            div.text-md.font-semibold.neutral700--text Applies to
            ul.mt-5(v-if="storedOffer.hasOwnProperty('upon_any_purchase')")
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.upon_any_purchase") All inventory & services
              li.text-md.neutral700--text.ml-2(v-else) Specific inventory and services ({{ storedOffer.purchase_products.length }})
          v-spacer
          y-button(label="Edit" size="sm" outlined :disabled="disableEdit('item_applies')" @click="updateEditable('item_applies')")
        template(v-if="storedOffer.hasOwnProperty('upon_any_purchase') && !storedOffer.upon_any_purchase")
          inventory-services-selection(v-model="storedOffer.purchase_products" readonly)

    //- reward_type
    v-card.pa-6.mt-4.round-xl(outlined)
      template(v-if="editable === 'reward_type'")
        div.text-md.font-semibold.neutral700--text Offers reward
        .text-sm.neutral700--text(style="margin-top: 2px;") Setup your offers reward
        v-radio-group.mt-0(v-model="offer.reward_type" @change="sanitizeUnusedObject(['discount_percentage', 'discount_amount', 'free_item_type', 'free_item_name'], ['free_products'])")
          v-row(no-gutters)
            v-col(cols="6")
              v-radio.mt-3(value="discount_percentage" color="neutral700")
                template(v-slot:label)
                  div
                    div.text-md.font-medium.neutral700--text Percentage discount (%)
                    div.text-sm.font-normal.neutral700--text Make a discount based on percentage of the full price
              template(v-if="offer.reward_type && offer.reward_type === 'discount_percentage'")
                v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="offer.discount_percentage" placeholder="0.0" outlined dense height="48" :rules="rules.not_empty" suffix="%" type="number" hide-details="auto")
          v-row(no-gutters)
            v-col(cols="6")
              v-radio.mt-3(value="discount_amount" color="neutral700")
                template(v-slot:label)
                  div
                    div.text-md.font-medium.neutral700--text Fixed amount discount (RM)
                    div.text-sm.font-normal.neutral700--text Make a discount based on a fixed amount
              template(v-if="offer.reward_type && offer.reward_type === 'discount_amount'")
                v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="offer.discount_amount" placeholder="0.00" outlined dense height="48" :rules="rules.not_empty" :prefix="$currency.symbol" type="number" hide-details="auto")
          v-row(no-gutters)
            v-col(cols="6")
              v-radio.mt-3(value="free_item" color="neutral700")
                template(v-slot:label)
                  div
                    div.text-md.font-medium.neutral700--text Free
                    div.text-sm.font-normal.neutral700--text Give free inventory/services/visit/other item
          v-row(no-gutters)
            v-col(cols="10")
              template(v-if="offer.reward_type && offer.reward_type === 'free_item'")
                div.ml-8
                  v-row
                    v-col(cols="6")
                      y-select.mt-2(v-model="offer.free_item_type" placeholder="Select reward" attach :items="[{ text: 'Applied inventory and services', value: 'product' }, { text: 'Visit', value: 'visit' }, { text: 'Other item', value: 'other' }]" item-text="text" item-value="value" :rules="rules.not_empty_select" @change="sanitizeUnusedObject(['free_item_name'], ['free_products'])")
                    v-col(v-if="offer.free_item_type && offer.free_item_type === 'other'")
                      v-text-field.text-sm.mt-2.round-xl(v-model="offer.free_item_name" placeholder="Enter item name" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
          div.ml-8(v-if="offer.reward_type && offer.reward_type === 'free_item' && offer.free_item_type && offer.free_item_type === 'product'")
            inventory-services-selection.mb-3(v-model="offer.free_products")
        div.d-flex.justify-end.mt-3
          y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="updateEditable(null)")
          y-button(label="Save" color="neutral700" size="sm" dark :loading="isLoading" @click="saveData")
      template(v-else)
        div.d-flex.align-center
          div
            div.text-md.font-semibold.neutral700--text Offers reward
            ul.mt-5(v-if="storedOffer.reward_type")
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.reward_type === 'discount_percentage'") {{ storedOffer.discount_percentage }}% percentage discount
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.reward_type === 'discount_amount'") Discount {{ storedOffer.discount_amount | displayPrice($currency) }}
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.reward_type === 'free_item' && storedOffer.free_item_type === 'visit'") Free visit
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.reward_type === 'free_item' && storedOffer.free_item_type === 'other'") Free item: {{ storedOffer.free_item_name }}
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.reward_type === 'free_item' && storedOffer.free_item_type === 'product'") Free:
          v-spacer
          y-button(label="Edit" size="sm" outlined :disabled="disableEdit('reward_type')" @click="updateEditable('reward_type')")
        template(v-if="storedOffer.reward_type === 'free_item' && storedOffer.free_item_type === 'product'")
          inventory-services-selection(v-model="storedOffer.free_products" readonly)

    //- usage_limit_type
    v-card.pa-6.mt-4.round-xl(outlined)
      template(v-if="editable === 'usage_limit_type'")
        v-row
          v-col(cols="6")
            div.text-md.font-semibold.neutral700--text Maximum discount uses
            .text-sm.neutral700--text(style="margin-top: 2px;") Set the usage limit of this offer
            v-radio-group.mt-0(v-model="offer.usage_limit_type" @change="sanitizeUnusedObject(['usage_limit'])")
              v-radio.mt-3(value="quantity" color="neutral700")
                template(v-slot:label)
                  div.text-md.font-medium.neutral700--text Limit number of times this discount can be used
              template(v-if="offer.usage_limit_type && offer.usage_limit_type === 'quantity'")
                v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="offer.usage_limit" placeholder="Enter number of times" outlined dense height="48" :rules="rules.not_empty" type="number" suffix="times" hide-details="auto")
              v-radio.mt-3(value="one_each" color="neutral700" style="align-items: unset;")
                template(v-slot:label)
                  div.text-md.font-medium.neutral700--text Limit to one use per customer
        div.d-flex.justify-end.mt-3
          y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="updateEditable(null)")
          y-button(label="Save" color="neutral700" size="sm" dark :loading="isLoading" @click="saveData")
      div.d-flex.align-center(v-else)
        div
          div.text-md.font-semibold.neutral700--text Offers usage limit
          ul.mt-5(v-if="storedOffer.usage_limit_type")
            li.text-md.neutral700--text.ml-2(v-if="storedOffer.usage_limit_type === 'quantity'") Limit usage to {{ storedOffer.usage_limit }} times
            li.text-md.neutral700--text.ml-2(v-if="storedOffer.usage_limit_type === 'one_each'") Limit to one use per customer
        v-spacer
        y-button(label="Edit" size="sm" outlined :disabled="disableEdit('usage_limit_type')" @click="updateEditable('usage_limit_type')")

    //- start_end
    v-card.pa-6.mt-4.round-xl(outlined)
      template(v-if="editable === 'start_end'")
        v-row
          v-col(cols="6")
            div.text-md.font-semibold.neutral700--text Active date and time
            .text-sm.neutral700--text(style="margin-top: 2px;") Set active period for this offer
            v-card.round-xl.mt-4(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
              div.pa-4
                v-row(dense)
                  v-col(cols="2")
                    div.text-md.font-medium.neutral700--text.mt-3 Starts
                  v-col.grow
                    date-picker-field(v-model="startDate")
                  v-col.grow
                    v-text-field.text-sm.round-xl(v-model="startTime" outlined dense height="48" :rules="rules.not_empty" type="time" hide-details="auto")
                v-row(v-if="setEndAt" dense)
                  v-col(cols="2")
                    div.text-md.font-medium.neutral700--text.mt-3 Ends
                  v-col.grow
                    date-picker-field(v-model="endDate" required)
                  v-col.grow
                    v-text-field.text-sm.round-xl(v-model="endTime" background-color="neutral100" outlined dense height="48" :rules="rules.not_empty" type="time" hide-details="auto")
                yc-checkbox.mt-3(v-model="setEndAt")
                  template(v-slot:label)
                    div.text-md.font-medium.neutral700--text.ml-3 Set end date and time
              v-divider.neutral300
              div.pa-4
                div.d-flex.align-center
                  div.text-md.font-medium.neutral700--text All-day
                  v-spacer
                  div
                    y-switch.mb-n2(v-model="offer.active_all_day" @change="sanitizeUnusedObject(['active_from', 'active_until'])")
                v-row.mt-3(v-if="!offer.active_all_day" dense)
                  v-col.shrink
                    div.text-sm.neutral700--text.mt-3 From
                  v-col.grow
                    v-text-field.text-sm.round-xl(v-model="offer.active_from" background-color="neutral100" outlined dense height="48" type="time" hide-details="auto")
                  v-col.shrink
                    div.text-sm.neutral700--text.mt-3 until
                  v-col.grow
                    v-text-field.text-sm.round-xl(v-model="offer.active_until" background-color="neutral100" outlined dense height="48" type="time" hide-details="auto")
        div.d-flex.justify-end.mt-3
          y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="updateEditable(null)")
          y-button(label="Save" color="neutral700" size="sm" dark :loading="isLoading" @click="saveData")
      div.d-flex.align-center(v-else)
        div
          div.text-md.font-semibold.neutral700--text Active date and time
          ul.mt-5
            li.text-md.neutral700--text.ml-2(v-if="storedOffer.is_start_immediately") Starts immediately after this offer is created
            li.text-md.neutral700--text.ml-2(v-else-if="storedOffer.start_at") Starts on {{ $options.filters.humanizeDate(storedOffer.start_at)}}
            li.text-md.neutral700--text.ml-2(v-if="storedOffer.end_at") Ends on {{ $options.filters.humanizeDate(storedOffer.end_at)}}
            li.text-md.neutral700--text.ml-2(v-else) No end date
            li.text-md.neutral700--text.ml-2(v-if="storedOffer.active_all_day") Eligible to be use all day
            li.text-md.neutral700--text.ml-2(v-else) Eligible to be use from {{ $options.filters.displayTime2(storedOffer.active_from) }} to {{ $options.filters.displayTime2(storedOffer.active_until) }}
        v-spacer
        y-button(label="Edit" size="sm" outlined :disabled="disableEdit('start_end')" @click="updateEditable('start_end')")

    //- thankyou_msg
    v-card.pa-6.mt-4.round-xl(outlined)
      template(v-if="editable === 'thankyou_msg'")
        v-row
          v-col(cols="10")
            div.text-md.font-semibold.neutral700--text I want to have thank you message for this offer
            .text-sm.neutral700--text(style="margin-top: 2px;") When enabled, you can setup a thank you message in Set deliverance settings. It allows you to send thank you message to your customer after the offer is redeemed or after the end of the campaign or after specific date and time.  
          v-col(cols="2")
            div.justify-end
              y-switch.mb-n2(v-model="offer.thankyou_msg_enabled")
        div.d-flex.justify-end.mt-3
          y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="updateEditable(null)")
          y-button(label="Save" color="neutral700" size="sm" dark :loading="isLoading" @click="saveData")
      div.d-flex.align-center(v-else)
        div
          div.text-md.font-semibold.neutral700--text Thank you message
          ul.mt-5
            li.text-md.neutral700--text.ml-2(v-if="storedOffer.thankyou_msg_enabled") Enabled
            li.text-md.neutral700--text.ml-2(v-else) Disabled
        v-spacer
        y-button(label="Edit" size="sm" outlined :disabled="disableEdit('thankyou_msg')" @click="updateEditable('thankyou_msg')")

    //- audience
    v-card.pa-6.mt-4.round-xl(outlined)
      template(v-if="editable === 'audience'")
        div.text-md.font-semibold.neutral700--text Audience eligibility
        .text-sm.neutral700--text(style="margin-top: 2px;") Choose which customer you would like to direct this offers to
        yc-checkbox.mt-5(v-model="offer.to_all_customers" :disabled="disableAudienceEligibilityEveryone")
          template(v-slot:label)
            div.text-md.font-medium.ml-3(:class="disableAudienceEligibilityEveryone ? 'neutral400--text' : 'neutral700--text'") Everyone
        yc-checkbox.mt-5(v-model="offer.to_all_loyalty_members" :disabled="disableAudienceEligibilityOther")
          template(v-slot:label)
            div.text-md.font-medium.ml-3(:class="disableAudienceEligibilityOther ? 'neutral400--text' : 'neutral700--text'") Loyalty members
        yc-checkbox.mt-5(v-model="audienceGroups" :disabled="disableAudienceEligibilityOther")
          template(v-slot:label)
            div.text-md.font-medium.ml-3(:class="disableAudienceEligibilityOther ? 'neutral400--text' : 'neutral700--text'") By segment
        div.ml-8(v-if="audienceGroups")
          segment-selection(v-model="offer.groups" :parent-offer="offer")
        yc-checkbox.mt-5(v-model="filterCustomers" :disabled="disableAudienceEligibilityOther")
          template(v-slot:label)
            div.text-md.font-medium.ml-3(:class="disableAudienceEligibilityOther ? 'neutral400--text' : 'neutral700--text'") Filter and select customers
        div.ml-8(v-if="filterCustomers")
          customer-selection.mb-6(v-model="offer.customers" :offer="offer")
        div.d-flex.justify-end.mt-3
          y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="updateEditable(null)")
          y-button(label="Save" color="neutral700" size="sm" dark :loading="isLoading" @click="saveData")
      template(v-else)
        div.d-flex.align-center
          div.text-md.font-semibold.neutral700--text.ml-2 Audience eligibility
          v-spacer
          y-button(label="Edit" size="sm" outlined :disabled="disableEdit('audience')" @click="updateEditable('audience')")
        ul.mt-5(v-if="storedOffer.to_all_customers")
          li.text-md.neutral700--text.ml-2 Everyone
        ul(v-if="storedOffer.to_all_loyalty_members")
          li.text-md.neutral700--text.ml-2 Loyalty members
        ul(v-if="storedOffer.groups.length")
          li.text-md.neutral700--text.ml-2 Specific group of customers:
        template(v-if="storedOffer.groups.length")
          segment-selection.mb-5(v-model="storedOffer.groups" :parent-offer="storedOffer" readonly)
        ul(v-if="storedOffer.customers.length")
          li.text-md.neutral700--text.ml-2 Specific customers:
        template(v-if="storedOffer.customers.length")
          customer-list(:offer="storedOffer")

    //- offer_deliverance
    v-card.pa-6.mt-4.round-xl(outlined)
      div.d-flex.align-center
        div
          div.d-flex.align-center
            v-icon(v-if="storedBlasts.filter(f => f.type === 'offer').length" size="24" color="success500") $yzi-check-circle-solid
            v-icon(v-else size="24" color="neutral500") $yzi-x-circle
            div.text-md.font-semibold.neutral700--text.ml-2 Offer deliverance
        v-spacer
        y-button(:label="storedBlasts.filter(f => f.type === 'offer').length ? 'Edit' : 'Set now'" size="sm" outlined @click="goToSetDeliveryMethods")
      template(v-if="storedBlasts.filter(f => f.type === 'offer').length")
        v-simple-table.mt-5
          thead
            tr(style="background-color: var(--v-neutral200)")
              th(style="width: 25%;") deliverance
              th blast frequency
          tbody
            template(v-for="(offer, index) in offersDeliverance")
              tr(:key="`off-${index}`")
                td.py-3
                  div.d-flex.align-center
                    v-avatar.mr-2(size="8" :color="offer.data ? 'success500' : 'blue500'")
                    div.text-sm.font-semibold.neutral700--text {{ getText(offer.method) }}
                td.py-3
                  div.d-flex.align-center
                    template(v-if="offer.data")
                      div.text-xs.neutral700--text(v-if="offer.data.send_cue === 'offer_activated'") Immediately after offer created
                      div.text-xs.neutral700--text(v-if="offer.data.send_cue === 'scheduled'") Blast later on {{ getScheduleText(offer.data.schedules) }}
                    template(v-else)
                      div.text-xs.neutral700--text Not set yet
        v-divider

    //- thank_you_deliverance
    v-card.pa-6.mt-4.round-xl(v-if="storedOffer.thankyou_msg_enabled" outlined)
      div.d-flex.align-center
        div
          div.d-flex.align-center
            v-icon(v-if="storedBlasts.filter(f => f.type === 'thank_you').length" size="24" color="success500") $yzi-check-circle-solid
            v-icon(v-else size="24" color="neutral500") $yzi-x-circle
            div.text-md.font-semibold.neutral700--text.ml-2 Thank you message deliverance
        v-spacer
        y-button(:label="storedBlasts.filter(f => f.type === 'thank_you').length ? 'Edit' : 'Set now'" size="sm" outlined @click="goToSetThankyouMessage")
      template(v-if="storedBlasts.filter(f => f.type === 'thank_you').length")
        v-simple-table.mt-5
          thead
            tr(style="background-color: var(--v-neutral200)")
              th(style="width: 25%;") deliverance
              th blast frequency
          tbody
            template(v-for="(thank, index) in thankYouMessage")
              tr(:key="`thx-${index}`")
                td.py-3
                  div.d-flex.align-center
                    v-avatar.mr-2(size="8" :color="thank.data ? 'success500' : 'blue500'")
                    div.text-sm.font-semibold.neutral700--text {{ getText(thank.method) }}
                td.py-3
                  div.d-flex.align-center
                    template(v-if="thank.data")
                      div.text-xs.neutral700--text {{ getSendToText(thank.data) }}
                        span.font-medium.ml-1(v-if="thank.data.send_to !== 'all'") {{ getSendCueText(thank.data) }}
                    template(v-else)
                      div.text-xs.neutral700--text Not set yet
        v-divider
                  
  div.py-16
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import InventoryServicesSelection from '@/components/clinic/marketing/InventoryServicesSelection.vue'
import SegmentSelection from '@/components/clinic/marketing/SegmentSelection.vue'
import CustomerSelection from '@/components/clinic/marketing/CustomerSelection.vue'
import CustomerList from '@/components/clinic/marketing/CustomerList.vue'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'

export default {
  components: { InventoryServicesSelection, SegmentSelection, CustomerSelection, CustomerList, DatePickerField },
  data () {
    return {
      isLoading: false,
      setEndAt: false,
      audienceGroups: false,
      filterCustomers: false,
      startDate: null,
      startTime: '00:00',
      endDate: null,
      endTime: '00:00',
      step: 0,
      editable: null,
      offer: {},
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      storedOffer: 'marketing/getOffer',
      storedBlasts: 'marketing/getBlasts',
    }),
    disableAudienceEligibilityEveryone () {
      if (this.offer.to_all_loyalty_members) {
        return true
      }
      if (this.audienceGroups) {
        return true
      }
      if (this.filterCustomers) {
        return true
      }
      return false
    },
    disableAudienceEligibilityOther () {
      if (this.offer.to_all_customers) {
        return true
      }
      return false
    },
    offersDeliverance () {
      let offers = [
        { method: 'sms', data: null },
        { method: 'whatsapp', data: null },
        { method: 'email', data: null }
      ]
      let blasts = this.storedBlasts
      if (blasts.find(f => f.method === 'sms' && f.type === 'offer')) {
        let data = blasts.find(f => f.method === 'sms' && f.type === 'offer')
        let offer = offers.find(f => f.method === 'sms')
        this.$set(offer, 'data', data)
      }
      if (blasts.find(f => f.method === 'email' && f.type === 'offer')) {
        let data = blasts.find(f => f.method === 'email' && f.type === 'offer')
        let offer = offers.find(f => f.method === 'email')
        this.$set(offer, 'data', data)
      }
      return offers
    },
    thankYouMessage () {
      let thanks = [
        { method: 'sms', data: null },
        { method: 'whatsapp', data: null },
        { method: 'email', data: null }
      ]
      let blasts = this.storedBlasts
      if (blasts.find(f => f.method === 'sms' && f.type === 'thank_you')) {
        let data = blasts.find(f => f.method === 'sms' && f.type === 'thank_you')
        let thank = thanks.find(f => f.method === 'sms')
        this.$set(thank, 'data', data)
      }
      if (blasts.find(f => f.method === 'email' && f.type === 'thank_you')) {
        let data = blasts.find(f => f.method === 'email' && f.type === 'thank_you')
        let thank = thanks.find(f => f.method === 'email')
        this.$set(thank, 'data', data)
      }
      return thanks
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      let offer = JSON.parse(JSON.stringify(this.storedOffer))
      this.audienceGroups = offer.groups.length > 0
      this.filterCustomers = offer.customers.length > 0
      if (offer.discount_amount) {
        offer.discount_amount = Number(offer.discount_amount) / this.$currency.multiplier
      }
      if (offer.start_at) {
        this.startDate = DateTime.fromISO(offer.start_at).toFormat('yyyy-MM-dd')
        this.startTime = DateTime.fromISO(offer.start_at).toFormat('HH:mm')
      }
      if (offer.end_at) {
        this.setEndAt = true
        this.endDate = DateTime.fromISO(offer.end_at).toFormat('yyyy-MM-dd')
        this.endTime = DateTime.fromISO(offer.end_at).toFormat('HH:mm')
      }
      this.offer = offer
    },
    sanitizeUnusedObject (strings, arrays) {
      if (strings && strings.length) {
        strings.forEach(f => {
          if (this.offer[f]) this.offer[f] = null
        })
      }
      if (arrays && arrays.length) {
        arrays.forEach(o => {
          if (this.offer[o]) this.offer[o] = []
        })
      }
    },
    updateEditable (section) {
      this.setData()
      this.editable = section
    },
    disableEdit (section) {
      if (['scheduled', 'draft'].includes(this.storedOffer.status)) {
        return false
      }
      if (this.storedOffer.status === 'active') {
        if (['name','thankyou_msg'].includes(section)) {
          return false
        }
      }
      return true
    },
    goToSetDeliveryMethods () {
      this.$store.commit('marketing/setOfferDetailsStep', 2)
    },
    goToSetThankyouMessage () {
      this.$store.commit('marketing/setOfferDetailsStep', 3)
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        this.$emit('error')
        return
      }
      this.isLoading = true
      let payload = JSON.parse(JSON.stringify(this.offer))
      if (!payload.name) {
        payload.name = 'Draft offer'
      }
      if (payload.discount_amount) {
        payload.discount_amount = Math.round(Number(payload.discount_amount) * this.$currency.multiplier)
      }
      if (this.startDate) {
        payload.start_at = `${this.startDate} ${this.startTime}`
      }
      if (this.setEndAt) {
        payload.end_at = `${this.endDate} ${this.endTime}`
      }
      payload.purchase_products = this.offer.purchase_products.map(m => m.id)
      payload.free_products = this.offer.free_products.map(m => m.id)
      payload.groups = this.offer.groups.map(m => { return { id: m.id, include_later_members: m.include_later_members } })
      if (this.offer.id) {
        for (const key in payload) {
          if (payload[key] === null) {
            delete payload[key];
          }
        }
        this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}`, payload)
          .then(resp => {
            this.$store.commit('marketing/setOffer', resp.data)
            this.$nextTick(() => {
              this.updateEditable(null)
            })
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
            this.$emit('error')
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        this.$axios.post(`/marketing/${this.company.slug}/offers`, payload)
          .then(resp => {
            this.$store.commit('marketing/setOffer', resp.data)
            this.$nextTick(() => {
              this.updateEditable(null)
            })
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
            this.$emit('error')
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    getText (method) {
      if (method === 'sms') return 'SMS'
      if (method === 'whatsapp') return 'WhatsApp API'
      if (method === 'email') return 'Email'
    },
    getSendToText (data) {
      let text = null
      if (data.send_to === 'redeemed_recipient') {
        text = 'Send to customer that redeemed the offer'
      } else if (data.send_to === 'all') {
        text = 'Send to everyone'
      }
      return text
    },
    getSendCueText (data) {
      let text = null
      if (data.send_cue === 'offer_redeemed') {
        text = `${data.auto_send_delay_time_value} min after redemption`
      } else if (data.send_cue === 'scheduled') {
        text = `on ${this.$options.filters.convertServerDate(data.schedules[0].scheduled_for)}`
      } else if (data.send_cue === 'offer_ended') {
        text = 'right after the campaign ended'
      }
      return text
    },
    getScheduleText (schedules) {
      let text = null
      if (schedules.length) {
        let datetimes = schedules.map(m => m.scheduled_for)
        if (datetimes.length > 2) {
          text = `${this.$options.filters.convertServerDate(datetimes[0])}, ${this.$options.filters.convertServerDate(datetimes[1])} and ${datetimes.length - 2} more`
        } else if (datetimes.length > 1) {
          text = `${this.$options.filters.convertServerDate(datetimes[0])} and ${this.$options.filters.convertServerDate(datetimes[1])}`
        } else {
          text = `${this.$options.filters.convertServerDate(datetimes[0])}`
        }
      }
      return text
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>